import {legacy_createStore as createStore, applyMiddleware, compose} from 'redux'
import createSagaMiddleware from 'redux-saga'
import {persistStore} from 'redux-persist'
import reducers from './reducer'
import rootSaga from './saga'

import {composeWithDevTools} from 'redux-devtools-extension'

const sagaMiddleware = createSagaMiddleware()

const DE_BUG = false

const bindMiddleware = (middleware: any[]) => {
	const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
	if (process.env.NODE_ENV !== 'production' && DE_BUG) {
		// 开发模式打印redux信息
		// eslint-disable-next-line @typescript-eslint/no-var-requires, no-undef
		const {logger} = require('redux-logger')
		middleware.push(logger)
		return composeWithDevTools(applyMiddleware(...middleware))
	}
	return composeEnhancers(applyMiddleware(...middleware))
}

const store = createStore(reducers, {} as any, bindMiddleware([sagaMiddleware]))
export const persistor = persistStore(store)
// const store = createStore(reducers, {}, applyMiddleware(sagaMiddleware))
sagaMiddleware.run(rootSaga)
export default store
